import { FormControl, TextField, Grid, Box,Button } from '@mui/material';

export const TextForReturnCertificate = ({useFetchInit, dataModal}) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { modalOpeningMode } = globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { ReturnCertificateForm } = Forms
    const { formState, onInputChange } = ReturnCertificateForm
    
    // ------------------------------------------------ FetchData
    
    // ------------------------------------------------ Actions
    const { onSubmitReturnCertificateModal } = Actions
    

    const { dataRequest } = dataModal
    // console.log(dataModal)
    // console.log(dataRequest)


    return (
        <>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl fullWidth>
                        <label htmlFor="nameToReturnToAdd">Emitido por:</label>
                        <TextField
                            id="nameToReturnToAdd"
                            name="nameToReturnToAdd"
                            value={formState.nameToReturnToAdd}
                            onChange={onInputChange}
                            size='small'
                            type="text"
                            variant="outlined"
                            InputProps={{
                                readOnly: false,
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl fullWidth>
                        <label htmlFor="addressToAdd">Dirección</label>
                        <TextField
                            id="addressToAdd"
                            name="addressToAdd"
                            value={formState.addressToAdd}
                            onChange={onInputChange}
                            size='small'
                            type="text"
                            variant="outlined"
                            InputProps={{
                                readOnly: false,
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl fullWidth>
                        <label htmlFor="phoneToAdd">Teléfono</label>
                        <TextField
                            id="phoneToAdd"
                            name="phoneToAdd"
                            value={formState.phoneToAdd}
                            onChange={onInputChange}
                            // label='Marca'
                            size='small'
                            type="text"
                            variant="outlined"
                            // hiddenLabel
                            InputProps={{
                                readOnly: false,
                            }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Box pt={4}>
                <Grid container spacing={2} justifyContent="flex-end">
                    <Grid item>
                        <Button 
                            variant='contained'
                            size='small'
                            color='success'
                            sx={{ marginRight: '8px' }}
                            onClick={() => onSubmitReturnCertificateModal(dataRequest.idreception)}
                            disabled={false}
                        >
                            GENERAR
                        </Button>
                    </Grid>
                    
                </Grid>
            </Box>
        </>
    )
}
